import { useQuery } from '@tanstack/react-query';

import { list as listFn } from '../../contracts-service';

export const contractOptions = (organizationId, queryParams, enabled) => ({
  queryKey: ['people-credits', organizationId],
  queryFn: () => listFn(organizationId, queryParams ?? {}),
  select: contracts =>
    contracts.map(({ creditsUsageByOrganization, userCredits, ...contract }) => ({
      used: creditsUsageByOrganization,
      limit: userCredits,
      ...contract,
    })),
  enabled,
});

export const useContracts = (organizationId, queryParams, enabled) =>
  useQuery(contractOptions(organizationId, queryParams, enabled));
